import { extendTailwindMerge } from 'tailwind-merge';
import tailwindConfig from 'tailwind.config';

const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [{ text: Object.keys(tailwindConfig.theme?.fontSize || {}) }],
            rounded: [
                {
                    rounded: Object.keys(tailwindConfig.theme?.borderRadius || {}),
                },
            ],
            z: [
                {
                    z: Object.keys(tailwindConfig.theme?.zIndex || {}),
                },
            ],
        },
        theme: {
            colors: Object.keys(tailwindConfig.theme?.colors || {}),
        },
    },
});

export default twMerge;
